
const hospitais = {
    "111111"  : "Descalvado", //MTExMTEx
    "222222"  : "Pongeluppe", //MjIyMjIy
    "2127881" : "Extrema" , //MjEyNzg4MQ==
    "9639659" : "Cosmopolis", //OTYzOTY1OQ==
    "2091267" : "Santa Rita", //MjA5MTI2Nw==
    "2790653" : "Perlati", //Mjc5MDY1Mw==
    "2747693" : "Ribeirão Bonito", //Mjc0NzY5Mw==
    "2745801" : "Morro Agudo", //Mjc0NTgwMQ==
    "2082632" : "Barra Bonita", //MjA4MjYzMg==
    "5288541" : "Santa Helena", //NTI4ODU0MQ==
    "2127695" : "Paraisopolis", //MjEyNzY5NQ==
    "2081717" : "Descalvado", //MjA4MTcxNw==
    "2747685" : "Nova Europa", //Mjc0NzY4NQ==
    "2079399" : "Tabatinga" //MjA3OTM5OQ==
}

export default hospitais;